import { render, staticRenderFns } from "./Audiogram.vue?vue&type=template&id=1ae37f0e&scoped=true"
import script from "./Audiogram.vue?vue&type=script&lang=js"
export * from "./Audiogram.vue?vue&type=script&lang=js"
import style0 from "./Audiogram.vue?vue&type=style&index=0&id=1ae37f0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae37f0e",
  null
  
)

export default component.exports